<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"></em-entity-edit-form>
                </div>
            </div>
            <!--富文本编辑器组件-->
            <!--<vue-editor v-model="content" />-->
        </section>
    </div>
</template>

<script>
    // Author thq
    // Date 2021-06-09 10:52:42

    import emCommonEditMixin from "@/mixin/em/common/edit";
    //import { VueEditor } from "vue2-editor";

    export default {
        name: "emAcctHandleRecordAhrEditView",
        //components: { VueEditor },
        mixins: [emCommonEditMixin],
        data(){
          return{
              content: "<h1>我是富文本编辑器</h1>"
          }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
        }
    };
</script>
